<div class="upload-section">

  <!-- ── Device dropdown ───────────────────────────────────────────────────── -->
  <div class="device-picker-wrap">
    <div class="device-picker-header">
      <p class="picker-label">Select Device</p>
      <button class="device-refresh-btn"
              [disabled]="isLoadingDevices || step === 'connecting' || step === 'streaming'"
              (click)="loadDevices()"
              title="Refresh device list"
              [featureActionState]="'MOBILE_AUTOMATION'">
        <span *ngIf="!isLoadingDevices">⟳</span>
        <span *ngIf="isLoadingDevices" class="device-refresh-spinner"></span>
      </button>
    </div>

    <!-- Loading state -->
    <div class="device-state-row" *ngIf="isLoadingDevices">
      <span class="device-list-spinner"></span>
      <span class="device-state-text">Loading devices…</span>
    </div>

    <!-- Error state -->
    <div class="device-state-row device-state-row--error"
         *ngIf="devicesLoadError && !isLoadingDevices">
      <span>⚠️</span>
      <span class="device-state-text">{{ devicesLoadError }}</span>
      <button class="device-retry-btn" (click)="loadDevices()" [featureActionState]="'MOBILE_AUTOMATION'">Retry</button>
    </div>

    <!-- Empty state -->
    <div class="device-state-row" *ngIf="!isLoadingDevices && !devicesLoadError && devices.length === 0">
      <span class="device-state-text">No devices found.</span>
    </div>

    <!-- Dropdown trigger -->
    <div class="device-dropdown-wrap"
         *ngIf="!isLoadingDevices && devices.length > 0">

      <button class="device-dropdown-trigger"
              [class.device-dropdown-trigger--open]="dropdownOpen"
              [class.device-dropdown-trigger--selected]="!!selectedDevice"
              [disabled]="step === 'connecting' || step === 'streaming'"
              (click)="toggleDropdown($event)"
              [featureActionState]="'MOBILE_AUTOMATION'">

        <ng-container *ngIf="!selectedDevice">
          <span class="ddt-placeholder">Select Device</span>
          <span class="ddt-chevron">▾</span>
        </ng-container>

        <ng-container *ngIf="selectedDevice">
          <span class="device-dot"
                [ngClass]="deviceStatusClass(selectedDevice)"
                style="margin-top:0; flex-shrink:0"></span>
          <span class="ddt-name">{{ selectedDevice.device_name }}</span>
          <span class="ddt-meta">
            <span class="device-chip device-chip--domain">{{ selectedDevice.domain }}</span>
            <span class="device-chip">Android {{ selectedDevice.platform_version }}</span>
          </span>
          <span class="ddt-chevron">{{ dropdownOpen ? '▴' : '▾' }}</span>
        </ng-container>
      </button>

      <!-- Dropdown list -->
      <div class="device-dropdown-list" *ngIf="dropdownOpen">
        <div class="device-dropdown-item device-dropdown-item--placeholder"
             (click)="resetDropdown();"
             (mousedown)="$event.preventDefault()">
          Select Device
        </div>
        <div class="device-dropdown-item"
             *ngFor="let d of devices"
             [class.device-dropdown-item--selected]="selectedDevice?._id === d._id"
             [class.device-dropdown-item--unavailable]="d.status !== 'online' || d.sessionStatus !== 'available'"
             (click)="d.status === 'online' && d.sessionStatus === 'available' && onDropdownSelect(d)">

          <span class="device-dot" [ngClass]="deviceStatusClass(d)" style="margin-top:0; flex-shrink:0"></span>

          <div class="device-card-body">
            <div class="device-card-name">{{ d.device_name }}</div>
            <div class="device-card-meta">
              <span class="device-chip">Android {{ d.platform_version }}</span>
              <span class="device-chip device-chip--type">{{ d.real_device ? 'Real' : 'Emulator' }}</span>
              <span class="device-chip device-chip--domain">{{ d.domain }}</span>
            </div>
          </div>

          <div class="device-card-right">
            <span class="device-status-badge" [ngClass]="deviceStatusClass(d)">
              {{ deviceStatusLabel(d) }}
            </span>
            <span class="device-selected-mark" *ngIf="selectedDevice?._id === d._id">✔</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ── Everything below is only shown once a device is selected ──────────── -->
  <ng-container *ngIf="selectedDevice">

    <!-- ── Platform toggle ─────────────────────────────────────────────────── -->
    <div class="panel-reveal">
      <div class="platform-toggle-wrap">
        <div class="platform-toggle" [class.disabled]="step === 'connecting' || step === 'streaming'">
          <button
            class="platform-btn"
            [class.platform-btn--active]="appType === 'native'"
            [disabled]="step === 'connecting' || step === 'streaming'"
            (click)="selectAppType('native')"
            title="Use UiAutomator2 driver for standard Android apps"
            [featureActionState]="'MOBILE_AUTOMATION'">
            <span class="platform-label">Native</span>
            <span class="platform-sub">UiAutomator2</span>
          </button>
          <button
            class="platform-btn"
            [class.platform-btn--active]="appType === 'flutter'"
            [disabled]="step === 'connecting' || step === 'streaming'"
            (click)="selectAppType('flutter')"
            title="Use Flutter Integration driver for Flutter apps"
            [featureActionState]="'MOBILE_AUTOMATION'">
            <span class="platform-label">Flutter</span>
            <span class="platform-sub">Integration</span>
          </button>
        </div>
        <p class="platform-hint" *ngIf="appType === 'flutter'">
          Flutter Integration driver — widget-tree locators (keys, labels, types).
        </p>
        <p class="platform-hint" *ngIf="appType === 'native'">
          UiAutomator2 driver — standard Android locators (resource-id, xpath, content-desc).
        </p>
      </div>

      <!-- ── Drop zone ───────────────────────────────────────────────────── -->
      <div class="drop-zone"
        [class.has-file]="!!selectedFile"
        [class.has-error]="step === 'error'"
        [class.is-flutter]="appType === 'flutter'"
        (dragover)="onDragOver($event)"
        (drop)="onDrop($event)"
        (click)="fileInput.click()"
        [featureActionState]="'MOBILE_AUTOMATION'">

        <input #fileInput type="file" accept=".apk, .xapk" hidden (change)="onFileSelected($event)">

        <ng-container *ngIf="!selectedFile">
          <div class="drop-icon">☁️</div>
          <p class="drop-label">Drop your <strong>Android APK</strong></p>
          <p class="drop-hint">or click to browse</p>
        </ng-container>

        <ng-container *ngIf="selectedFile">
          <div class="file-info">
            <div class="file-meta">
              <span class="file-name">{{ selectedFile.name }}</span>
              <span class="file-size">
                {{ fileSizeMB }} MB ·
                <span class="file-platform-badge" [class.file-platform-badge--flutter]="appType === 'flutter'">
                  {{ appType === 'flutter' ? 'Flutter' : 'Android' }}
                </span>
              </span>
            </div>
            <button class="file-clear" (click)="clearFile(); $event.stopPropagation()" [featureActionState]="'MOBILE_AUTOMATION'">✕</button>
          </div>
        </ng-container>
      </div>

      <!-- ── Error banner ─────────────────────────────────────────────────── -->
      <div class="error-banner" *ngIf="step === 'error' && errorMessage">
        <span>⚠️</span>
        <span>PLEASE TRY AGAIN</span>
        <button class="error-dismiss" (click)="dismissError()" [featureActionState]="'MOBILE_AUTOMATION'">✕</button>
      </div>

      <!-- ── Upload progress ───────────────────────────────────────────────── -->
      <div class="progress-wrap" *ngIf="isUploading">
        <div class="progress-bar">
          <div class="progress-fill" [style.width.%]="uploadProgress"></div>
        </div>
        <span class="progress-label">Uploading… {{ uploadProgress }}%</span>
      </div>

      <!-- ── Start button ──────────────────────────────────────────────────── -->
      <button class="btn-start"
        [class.btn-start--flutter]="appType === 'flutter'"
        [disabled]="!selectedFile || !selectedDevice || !isDeviceAvailable || isUploading || step === 'connecting' || step === 'streaming'"
        (click)="uploadAndStart()"
        [featureActionState]="'MOBILE_AUTOMATION'">
        <span *ngIf="!isUploading && step !== 'connecting'">
          Upload &amp; Start Session
        </span>
        <span *ngIf="isUploading">Uploading {{ uploadProgress }}%…</span>
        <span *ngIf="step === 'connecting' && !isUploading">Connecting…</span>
      </button>
    </div>

  </ng-container>

</div>